<template>
  <div class="sliderLogotypes" :class="[`sliderLogotypes--${size}`]">
    <SwiperSlider ref="sliderLogotypes" class="sliderLogotypes__slider" :options="swiperOptions">
      <div v-for="(item, index) in items" :key="index" class="sliderLogotypes__slide swiper-slide">
        <div class="sliderLogotypes__image">
          <NuxtLink v-if="item.to" :to="item.to">
            <NewImageBox
              :src="item.image"
              :width="300"
              :height="120"
              :alt="item.name"
              fit-contain-center
              image-params="w_300,h_150"
            />
          </NuxtLink>
          <NewImageBox
            v-else
            :src="item.image"
            :width="300"
            fit-contain-center
            :height="120"
            :alt="item.name"
            image-params="w_300,h_150"
          />
        </div>
      </div>
    </SwiperSlider>
    <SliderButton position="prev" @click="prevEl" :disabled="prevDisable" />
    <SliderButton position="next" @click="nextEl" :disabled="nextDisable" />
  </div>
</template>

<script>
import SwiperSlider from '@/components/SwiperSlider.vue';
import NewImageBox from '@/components/NewImageBox.vue';
import SliderButton from '@/components/Sliders/SliderButton.vue';

export default {
  name: 'SliderLogotypes',
  components: { SliderButton, NewImageBox, SwiperSlider },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  data() {
    return {
      nextDisable: false,
      prevDisable: false,
      swiperOptions: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        loop: false,
        speed: 600,
        spaceBetween: 0,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 4,
        },
        navigation: true,
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.sliderLogotypes.swiper !== 'undefined') {
        return this.$refs.sliderLogotypes.swiper;
      }
      return false;
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.checkArrows();
      });

      this.swiper.once('update', () => {
        this.swiper.on('slideChange', () => {
          this.checkArrows();
        });
      });

      this.checkArrows();
    }
  },
  methods: {
    refreshSlider() {
      this.swiper.update();
      this.checkArrows();
    },
    checkArrows() {
      this.nextDisable = this.swiper.isEnd;
      this.prevDisable = this.swiper.activeIndex === 0;
    },
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sliderLogotypes {
  $root: &;
  position: relative;
  padding: 0 1rem;

  &__slider {
    margin: 0 -8px;
  }

  &__slide {
    height: auto;
    padding-left: 8px;
    padding-right: 8px;
  }

  &__image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 2rem;
  }

  a {
    transition: opacity $tr;
    &:hover {
      opacity: 0.6;
    }
  }

  &--normal {
    #{$root}__slide {
      width: 14.285%;

      @include rwd('laptop') {
        width: 16.666%;
      }

      @include rwd('tablet') {
        width: 25%;
      }

      @include rwd('small-tablet') {
        width: 33.333%;
      }

      @include rwd('large-phone') {
        width: 50%;
      }
    }
  }

  &--small {
    #{$root}__slide {
      width: 11.11%;

      @include rwd('laptop') {
        width: 14.285%;
      }

      @include rwd('tablet') {
        width: 25%;
      }

      @include rwd('large-phone') {
        width: 33.333%;
      }

      @include rwd('phone') {
        width: 50%;
      }
    }
  }

  &--big {
    #{$root}__slide {
      width: 20%;

      @include rwd('laptop') {
        width: 25%;
      }

      @include rwd('tablet') {
        width: 33.333%;
      }

      @include rwd('large-phone') {
        width: 50%;
      }

      @include rwd('phone') {
        width: 100%;
      }
    }
  }
}
</style>
